<template>
   <div class="text-center mx-auto mt-4 flex-none text-sm">
       <button type="button" class="appearance-none outline-none bg-none text-gray-1 underline">
           {{ label.profile.btnCancelMember }}
           <!-- <a href="tel:02-645-1212">02-645-1212</a> -->
       </button>
   </div>
</template>
<script>
   export default {
       name: 'CancelMember',
       inject: ["label"],
   }
</script>
